module.exports = __webpack_public_path__ + "static/media/samruddhi2.4dee74e4.jpeg";